<template>
  <v-card flat>
    <gmap-map id="map"
              :center="map.center"
              :zoom="map.zoom"
              :options="map.options">

      <gmap-info-window :options="map.infoOptions"
                        :position="map.infoWindowPos"
                        :opened="map.infoWinOpen"
                        @closeclick="map.infoWinOpen=false">
        <v-card flat
                width="300px">
          <v-card-title class="px-0">
            <v-layout row>
              <v-flex xs7>
                <h3 class="mb-2">{{ map.markerSelected.prescriptorName }}</h3>
                <p class="mb-2">{{ map.markerSelected.prescriptorAddress }}</p>
                <p v-if="map.markerSelected.prescriptorObservation"
                   v-html="map.markerSelected.prescriptorObservation">
                </p>
              </v-flex>
              <v-flex xs5>
                <v-img :src="map.markerSelected.prescriptorImage"
                       contain
                       class="pa-2"
                       height="80px"></v-img>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </gmap-info-window>

      <gmap-marker :key="index"
                   v-for="(m, index) in markers"
                   :position="m.position"
                   :clickable="true"
                   :draggable="false"
                   :title="m.title"
                   :icon="m.icon"
                   @click="toggleInfoWindow(m,index)"></gmap-marker>
    </gmap-map>
  </v-card>
</template>

<script>
import prescriptorService from '@/services/prescriptorService';
import manageErrorService from '@/services/manageErrorService';
import utilService from '@/services/utilService';
import _ from 'lodash';
import store from '@/store';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'PrescriptorMap',
  computed: {
    selectedCity() {
      return store.state.citySelected;
    },
    back() {
      if (typeof this.$route.query.back !== 'undefined') {
        return this.$route.query.back;
      }
      return false;
    }
  },
  data() {
    return {
      markers: [],
      map: {
        options: {
          scrollwheel: false,
          clickableIcons: true,
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false
        },
        center: {},
        currentMidx: null,
        infoWindowPos: null,
        infoWinOpen: false,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        markerSelected: {
          prescriptorImage: '',
          prescriptorName: '',
          prescriptorAddress: '',
          prescriptorObservation: ''
        }
      }
    };
  },
  mounted() {
    let routeObj = { path: this.$i18n.t('urlTeletac') };
    if (this.back) {
      routeObj = { path: this.$i18n.t('urlTeletac'), query: { show: this.back } };
    }

    EventBus.$emit(keys.goToUrl, { routeObj: routeObj });
  },
  created() {
    this.map.center = {
      lat: Number(this.selectedCity.lat),
      lng: Number(this.selectedCity.lon)
    };
    // no nos sive el mismo zoom que el mapa normal
    if (utilService.isChile()) {
      this.map.zoom = 11;
    } else {
      this.map.zoom = 10;
    }

    this.getPrescriptor();
  },
  methods: {
    async getPrescriptor() {
      let results = await prescriptorService.list();
      if (results.error) {
        manageErrorService.handle(results.data);
        return;
      }

      this.markers = [];
      _.each(results.data, prescriptor => {
        this.markers.push({
          position: { lat: prescriptor.lat, lng: prescriptor.lon },
          icon: prescriptor.logo.web.normal,
          image: prescriptor.logo.ios.x2,
          // icon: 'https://9sp-asset.s3.eu-west-1.amazonaws.com/pre/public/prescriptors/web_1x_marker-shop.png',
          title: prescriptor.precriptor,
          id: prescriptor.id,
          address: prescriptor.address,
          observation: prescriptor.observation
        });
      });
    },

    toggleInfoWindow(marker, idx) {
      this.map.infoWindowPos = marker.position;

      this.map.markerSelected = {
        prescriptorImage: marker.image,
        prescriptorName: marker.title,
        prescriptorAddress: marker.address,
        prescriptorObservation: marker.observation
      };

      if (this.map.currentMidx === idx) {
        this.map.infoWinOpen = !this.map.infoWinOpen;
      } else {
        this.map.infoWinOpen = true;
        this.map.currentMidx = idx;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#map {
  height: calc(100vh - 50px);
  width: auto;
}
</style>

<style lang="scss">
.gm-ui-hover-effect {
  right: 0px !important;
  top: 0px !important;
}
.gm-ui-hover-effect img {
  background-image: url('/image/public/cross.svg');
  background-repeat: no-repeat;
}
.gm-style-iw-c {
  padding-left:23px !important;
  padding-right:5px !important;
}
// .gm-style-iw gm-style-iw-c {
//   padding:0px !important;
// }
// .gm-style-iw + div {display: none !important; }
</style>
